import { AppLoading } from '@/components/AppLoading'
import { EmailSignInForm } from '@/containers/public/email/SignIn/EmailSignInForm'
import { getLoginTypeDescription, useGetPublicEmailLoginInfo } from '@/hooks/usePublicEmail'
import {
  Alert,
  AlertDescription,
  Link,
  Stack,
  Text
} from '@chakra-ui/react'
import { formatDate } from 'BrokerTsLib/src/Utils/formatDate'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { EmailPageLayout } from './EmailPageLayout'


export function EmailSignInPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const tokenStr = searchParams.get('token') || undefined

  const { data: loginInfo, error: loginInfoError } = useGetPublicEmailLoginInfo(tokenStr)

  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (loginInfoError) {
      const errRes = (loginInfoError as any)?.response?.data
      setErrorMessage(typeof errRes === 'string' ? errRes : 'Nastala chyba při načítání údajů. Zkontrolujte správnost odkazu.')
    }
  }, [loginInfoError])

  useEffect(() => {
    if (!tokenStr)
      setErrorMessage('Odkaz je neplatný. Zkontrolujte prosím url adresu a zkuste to znovu.')
  }, [tokenStr])

  if (!loginInfo && !errorMessage)
    return <AppLoading />

  const isCalculation = loginInfo?.emailTypeStr?.toLowerCase() === 'calculation'

  return (
    <EmailPageLayout>
      {errorMessage &&
        <Alert
          status='error'
          variant='left-accent'
          fontSize={'xl'}
          p={8}
        >
          {errorMessage}
        </Alert>
      }

      {!errorMessage && loginInfo && <Alert colorScheme='gray' variant='left-accent' p={{ base: 3, md: 8 }}>
        <AlertDescription>
          <Stack gap={3}>
            <Text>{loginInfo?.salutation} <br />
              ke zpracování {isCalculation ? <>kalkulace č.: <b>{loginInfo?.paramsId}</b></> : <>smlouvy č.: <b>{loginInfo?.contractNumber}</b></>} jsou třeba údaje, které jsou dle platné legislativy považovány za osobní údaje.
            </Text>
            <Text mt={0}>
              Udělení souhlasu se zpracováním osobních údajů pro účely sjednávání a uzavírání pojistných smluv, potvrďte prosím zadáním {loginInfo ? getLoginTypeDescription(loginInfo.isRcLoginType, loginInfo.isForeigner) : ''} pojistníka a stiskem tlačítka <b>„Uděluji souhlas”</b>.
            </Text>

            <Text>Tento souhlas udělujete na dobu platnosti této {isCalculation ? 'kalkulace' : 'smlouvy'}.</Text>

            {loginInfo.privacyNoticeDocumentUrl ? (
              <Text>Podrobný přehled o zpracování osobních údajů naleznete v dokumentu <Link href={loginInfo.privacyNoticeDocumentUrl} target="_blank" color="blue.600">Informace o zpracování osobních údajů</Link>.</Text>
            ) : (
              <Text>Informace o zpracování osobních údajů Vám poskytne Váš poradce nebo je můžete získat na vyžádání u správce osobních údajů.</Text>
            )}

            <Text>Tento email i dokumenty, které zpřístupníte udělením souhlasu jsou platné pouze do <b>{formatDate(new Date(loginInfo.validTo))}</b>. Dokumenty si prosím uložte do svého zabezpečeného úložiště.</Text>

            <Text>Děkujeme Vám za projevenou důvěru.</Text>
          </Stack>
        </AlertDescription>
      </Alert>}

      {!errorMessage && loginInfo &&
        <EmailSignInForm
          loginInfo={loginInfo}
          submitCallback={() => {
            navigate('/public/email')
          }}
        />
      }
    </EmailPageLayout>
  )
}
